export default __webpack_public_path__ + "static/media/LilNounsReadingAltNouns.b24fa36b.png";